/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EventsControllerDtoDrawItemLogListDrawItemLogData model module.
 * @module model/EventsControllerDtoDrawItemLogListDrawItemLogData
 * @version 1.0
 */
class EventsControllerDtoDrawItemLogListDrawItemLogData {
    /**
     * Constructs a new <code>EventsControllerDtoDrawItemLogListDrawItemLogData</code>.
     * @alias module:model/EventsControllerDtoDrawItemLogListDrawItemLogData
     */
    constructor() { 
        
        EventsControllerDtoDrawItemLogListDrawItemLogData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EventsControllerDtoDrawItemLogListDrawItemLogData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoDrawItemLogListDrawItemLogData} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoDrawItemLogListDrawItemLogData} The populated <code>EventsControllerDtoDrawItemLogListDrawItemLogData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoDrawItemLogListDrawItemLogData();

            if (data.hasOwnProperty('logNo')) {
                obj['logNo'] = ApiClient.convertToType(data['logNo'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('rewardNo')) {
                obj['rewardNo'] = ApiClient.convertToType(data['rewardNo'], 'Number');
            }
            if (data.hasOwnProperty('walletTransactionNo')) {
                obj['walletTransactionNo'] = ApiClient.convertToType(data['walletTransactionNo'], 'Number');
            }
            if (data.hasOwnProperty('drawCount')) {
                obj['drawCount'] = ApiClient.convertToType(data['drawCount'], 'Number');
            }
            if (data.hasOwnProperty('itemId')) {
                obj['itemId'] = ApiClient.convertToType(data['itemId'], 'Number');
            }
            if (data.hasOwnProperty('itemCount')) {
                obj['itemCount'] = ApiClient.convertToType(data['itemCount'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoDrawItemLogListDrawItemLogData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoDrawItemLogListDrawItemLogData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }

        return true;
    }


}



/**
 * @member {Number} logNo
 */
EventsControllerDtoDrawItemLogListDrawItemLogData.prototype['logNo'] = undefined;

/**
 * @member {Number} accountNo
 */
EventsControllerDtoDrawItemLogListDrawItemLogData.prototype['accountNo'] = undefined;

/**
 * @member {String} email
 */
EventsControllerDtoDrawItemLogListDrawItemLogData.prototype['email'] = undefined;

/**
 * @member {Number} rewardNo
 */
EventsControllerDtoDrawItemLogListDrawItemLogData.prototype['rewardNo'] = undefined;

/**
 * @member {Number} walletTransactionNo
 */
EventsControllerDtoDrawItemLogListDrawItemLogData.prototype['walletTransactionNo'] = undefined;

/**
 * @member {Number} drawCount
 */
EventsControllerDtoDrawItemLogListDrawItemLogData.prototype['drawCount'] = undefined;

/**
 * @member {Number} itemId
 */
EventsControllerDtoDrawItemLogListDrawItemLogData.prototype['itemId'] = undefined;

/**
 * @member {Number} itemCount
 */
EventsControllerDtoDrawItemLogListDrawItemLogData.prototype['itemCount'] = undefined;

/**
 * @member {Date} createdAt
 */
EventsControllerDtoDrawItemLogListDrawItemLogData.prototype['createdAt'] = undefined;






export default EventsControllerDtoDrawItemLogListDrawItemLogData;

